
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Touchez « Ouvrir dans le navigateur… »`,
's182ab2d6c997515f': `Ajoutez-le à votre écran d'accueil pour une expérience étendue et un accès facile.`,
's224cbcec014ef6b5': `Appuyez sur Partager dans la barre de navigation`,
's233af3b7eb5e0364': `Ajouter à la Maison`,
's37a9e8aec5713460': `Plus`,
's4c3161035f3a1413': `Appuyez sur Menu`,
's4e1e10a6ca408245': `Touchez "Ajouter à l'écran d'accueil"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Ouvrez le menu de votre navigateur`,
's681e399d63311fba': `Afficher la galerie`,
's6d14a4f70ba4e3cf': `Appuyez sur Menu s'il n'y a pas d'icône Partager`,
's922329d6f6213590': `Ajouter au Dock`,
's9c63a79ffcc2a3a3': `Appuyez sur "Ajouter à l'écran d'accueil"`,
'sa2d71bfd9525168d': `Appuyez sur "Ajouter au Dock"`,
'sa5ef80b4bb9b39f8': `Moins`,
'sb527eca1c1d7e7be': `Ouvrez le menu du navigateur intégré`,
'sba52286c21552a4e': `Installez-le sur votre appareil pour une expérience complète et un accès facile.`,
'sc16e00a7a8b2fde2': `Retour`,
'scdaf4bbff76674c8': `Ajouter à l'écran d'accueil`,
'sd18a5b85f599ff3c': `Ouvrez le lien copié dans Safari`,
'se72fc3a84f9b51c3': `Touchez pour copier le lien`,
'se740f75b95a51807': `Ajoutez-le à votre Dock pour une expérience étendue et un accès facile.`,
'sfa6c42cdf48d93d2': `Mais ce navigateur ne prend pas en charge cette fonctionnalité. Ouvrez le lien dans un navigateur externe pour continuer.`,
'sfb78526365796a41': `Appuyez sur "Afficher plus" dans le menu Partager`,
'sfea652f6580ff086': `Ce site possède des fonctionnalités d'application.`,
    };
  